export enum BenefitTabs {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UPCOMING = 'UPCOMING',
  PAST = 'PAST',
  HIDDEN = 'HIDDEN'
}

export const BenefitTabsTranslation = {
  [BenefitTabs.ACTIVE]: 'Aktywne',
  [BenefitTabs.INACTIVE]: 'Usunięte',
  [BenefitTabs.UPCOMING]: 'Nadchodzące',
  [BenefitTabs.PAST]: 'Przeszłe',
  [BenefitTabs.HIDDEN]: 'Robocze'
};
